"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
// All translations related to social media
var SocialMedia = {
  osn_social: {
    nl: 'OSN#Social',
    fr: 'OSN#Social',
    en: 'OSN#Social',
    de: 'OSN#Social'
  },
  socialMedia: {
    nl: 'Social media',
    fr: 'Social media',
    en: 'Social media',
    de: 'Soziale Medien'
  },
  post: {
    nl: 'Post',
    fr: 'Post',
    en: 'Post',
    de: 'Post'
  },
  whatsapp: {
    nl: 'WhatsApp',
    fr: 'WhatsApp',
    en: 'WhatsApp',
    de: 'WhatsApp'
  },
  skype: {
    nl: 'Skype',
    fr: 'Skype',
    en: 'Skype',
    de: 'Skype'
  },
  facebook: {
    nl: 'Facebook',
    fr: 'Facebook',
    en: 'Facebook',
    de: 'Facebook'
  },
  twitter: {
    nl: 'Twitter',
    fr: 'Twitter',
    en: 'Twitter',
    de: 'Twitter'
  },
  google: {
    nl: 'Google',
    fr: 'Google',
    en: 'Google',
    de: 'Google'
  },
  youtube: {
    nl: 'YouTube',
    fr: 'YouTube',
    en: 'YouTube',
    de: 'YouTube'
  },
  youtube_video: {
    nl: 'YouTube video',
    fr: 'YouTube vidéo',
    en: 'YouTube video',
    de: 'YouTube-Video'
  },
  vimeo: {
    nl: 'Vimeo',
    fr: 'Vimeo',
    en: 'Vimeo',
    de: 'Vimeo'
  },
  vimeo_video: {
    nl: 'Vimeo video',
    fr: 'Vimeo vidéo',
    en: 'Vimeo video',
    de: 'Vimeo-Video'
  },
  linkedin: {
    nl: 'LinkedIn',
    fr: 'LinkedIn',
    en: 'LinkedIn',
    de: 'LinkedIn'
  },
  pinterest: {
    nl: 'Pinterest',
    fr: 'Pinterest',
    en: 'Pinterest',
    de: 'Pinterest'
  },
  instagram: {
    nl: 'Instagram',
    fr: 'Instagram',
    en: 'Instagram',
    de: 'Instagram'
  },
  tumblr: {
    nl: 'Tumblr',
    fr: 'Tumblr',
    en: 'Tumblr',
    de: 'Tumblr'
  },
  flickr: {
    nl: 'Flickr',
    fr: 'Flickr',
    en: 'Flickr',
    de: 'Flickr'
  },
  snapchat: {
    nl: 'Snapchat',
    fr: 'Snapchat',
    en: 'Snapchat',
    de: 'Snapchat'
  },
  vine: {
    nl: 'Vine',
    fr: 'Vine',
    en: 'Vine',
    de: 'Vine'
  },
  dribbble: {
    nl: 'Dribbble',
    fr: 'Dribbble',
    en: 'Dribbble',
    de: 'Dribbble'
  },
  behance: {
    nl: 'Behance',
    fr: 'Behance',
    en: 'Behance',
    de: 'Behance'
  },
  foursquare: {
    nl: 'Foursquare',
    fr: 'Foursquare',
    en: 'Foursquare',
    de: 'Foursquare'
  },
  deviantart: {
    nl: 'Deviantart',
    fr: 'Deviantart',
    en: 'Deviantart',
    de: 'DeviantArt'
  },
  wordpress: {
    nl: 'WordPress',
    fr: 'WordPress',
    en: 'WordPress',
    de: 'WordPress'
  }
};
var _default = SocialMedia;
exports["default"] = _default;